import { setIsSalidasLoading, setSalidas } from '../dashRedux'
import { getSalidas } from '../restFunctios/getSalidas'

export const getSalidasAction = q => {
  return async dispatch => {
    dispatch(setIsSalidasLoading(true))
    const { data } = await getSalidas(q)
    if (data) {
      dispatch(setSalidas(data.entities))
      dispatch(setIsSalidasLoading(false))
    } else {
      dispatch(setSalidas([]))
      dispatch(setIsSalidasLoading(false))
    }
  }
}
